import {
  ChangeToApprove,
  ETenantSettingActionType
} from './tenant-setting-change';
import {Tag} from '../../../../domain/tag';

export class InsertTagChangeToApprove extends ChangeToApprove {
  constructor(
    public tag: Tag,
    public message: string
  ) {
    super(tag.id, ETenantSettingActionType.InsertTag, message);
  }
}
